import vec2 from '@/helpers/vec2'
import range from '@/helpers/range'

import { RainDrop, Color } from './constants'
import random from './random'

const prng = random.create()

const drops = []

export function update (cx, data) {
  if (!data) {
    return
  }
  const { width, height } = cx.canvas
  const halfWidth = width >> 1
  const halfHeight = height >> 1
  // TODO: Right now we do not have this data available on the simulation.
  const rain = {
    maxParticles: Math.round(data.Pcp * 50)
  }
  for (let index = 0; index < drops.length; index++) {
    const drop = drops[index]
    drop.shouldRenderNextTime = index < rain.maxParticles
    vec2.add(drop.position, drop.position, drop.velocity)
    if (vec2.y(drop.position) >= 0) {
      vec2.set(
        drop.position,
        prng.between(-halfWidth, halfWidth),
        prng.between(-height, -halfHeight)
      )
      drop.shouldRender = drop.shouldRenderNextTime
    }

    if (vec2.x(drop.position) <= -halfWidth
      || vec2.x(drop.position) >= halfWidth) {
      vec2.set(
        drop.position,
        prng.between(-halfWidth, halfWidth),
        prng.between(-height, -halfHeight)
      )
    }
  }
}

export function render (cx) {
  const { height } = cx.canvas
  const halfHeight = height >> 1
  const quarterHeight = height >> 2
  cx.save()
  for (const drop of drops) {
    if (!drop.shouldRender) {
      continue
    }
    const [x, y] = drop.position
    const [vx, vy] = drop.velocity
    cx.beginPath()
    cx.moveTo(x - vx, y - vy)
    cx.lineTo(x + vx, y + vy)
    cx.strokeStyle = Color.RAIN(range.from(drop.position[1], -halfHeight, -quarterHeight))
    cx.stroke()
  }
  cx.restore()
}

export function init (cx) {
  const { width, height } = cx.canvas
  const halfWidth = width >> 1
  const halfHeight = height >> 1
  for (let index = 0; index < RainDrop.COUNT; index++) {
    drops.push({
      shouldRenderNextTime: false,
      shouldRender: false,
      velocity: vec2.create(0, prng.between(20, 30)),
      position: vec2.create(
        prng.between(-halfWidth, halfWidth),
        prng.between(-height, -halfHeight)
      )
    })
  }
}

export function resize (canvas) {
  const { width, height } = canvas
  const halfWidth = width >> 1
  const halfHeight = height >> 1
  for (const drop of drops) {
    vec2.set(
      drop.position,
      prng.between(-halfWidth, halfWidth),
      prng.between(-height, -halfHeight)
    )
  }
}

export function destroy () {
  drops.splice(0, drops.length)
}

export default {
  init,
  resize,
  destroy,
  render,
  update
}
